import { ARCHIVE_SLICE, archiveRoot } from 'utils/archiveRoot'

// The All tab and page 1 are the bare /perspectives/, which also has to start
// at the hero when reached from anywhere else. Only the referrer tells a click
// on the archive's own tabs or pager apart from that.
function cameFromSameArchive() {
    if (!document.referrer) return false
    const from = new URL(document.referrer)
    return from.origin === window.location.origin
        && archiveRoot(from.pathname) === archiveRoot(window.location.pathname)
}

// How much of the top of the viewport the navbar covers, which the archive has
// to stop below. Only the -fixed bar overlays the page, and only once it
// exists: on a page still at the top, .navigation is the tall header in the
// document flow, and subtracting its height would land a screen's worth of the
// section above the archive in view.
function fixedNavHeight() {
    const nav = document.querySelector('.js-navigation')
    return nav && nav.classList.contains('-fixed') ? nav.offsetHeight : 0
}

/**
 * Put the perspectives archive in view (IV-1696).
 *
 * Only when the URL itself names a page or a query, or the reader came from
 * another slice of the same archive — /perspectives/ otherwise starts at the top.
 *
 * @param {Object} [options]
 * @param {string} [options.behavior] - 'auto' for a fresh page load, where a
 *   4000px smooth scroll would be a long animation over content nobody asked
 *   to see.
 */
export default function scrollToPosts({behavior = 'smooth'} = {}) {
    const urlParams = new URLSearchParams(window.location.search)
    if (ARCHIVE_SLICE.test(window.location.pathname) || urlParams.has('query') || urlParams.has('page') || cameFromSameArchive()) {
        const postsContainer = document.querySelector('#all_posts')
        if (postsContainer) {
            const topPosition = window.scrollY
                + postsContainer.getBoundingClientRect().top
                - fixedNavHeight()
            window.scrollTo({top: topPosition, behavior})
        }
    }
}
